module.exports = "https://cdn2-fs.clearscore.com/flux/images/040b2f015c57442d02db17031f50d520.jpg";